import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { selectEdition, selectInstallVersion } from 'selectors/app'
import { formatVersionMajorMinor } from 'helpers/versionRoutines'
import { NW_JS_APP_PROFILES } from '~/enums'

function AppWindowTitle() {
  // dont manipulate title with on premis deployment since it blinks from original at index.html
  // should override original index.html and favicon.ico
  // manipulate only for nwjsProfiles and if it was overriden with devProfile
  const installVersion = useSelector(selectInstallVersion)
  const edition = useSelector(selectEdition)
  const { favIcon, appTitle, appDescription } = useSelector(state => state.user)
  let titleText = appTitle
  const nwjsProfiles = NW_JS_APP_PROFILES.includes(__APP_PROFILE__)
  if (nwjsProfiles && edition) {
    titleText = `${appTitle || __CFG__.TITLE} ${formatVersionMajorMinor(installVersion)} ${edition}`
  }
  const descriptionText = appDescription
  return (
    <Helmet>
      {favIcon && <link rel="icon" href={favIcon} />}
      {titleText && <title>{titleText}</title>}
      {descriptionText && <meta name="description" content={descriptionText} />}
    </Helmet>
  )
}

export default AppWindowTitle
